import React from 'react';
import styled from 'styled-components';

// Aday etiketi rozeti. Renk KİRACININ katalog verisidir (tema rengi değil) —
// kullanıcı etiketi renkle ayırt ediyor; renk yoksa tema birincil rengi.
const Wrap = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  line-height: 18px;
  white-space: nowrap;
  color: ${({ $color, theme }) => $color || theme.colors.primary.main};
  background: ${({ $color }) => ($color ? `${$color}1F` : 'rgba(2, 145, 239, 0.1)')};
  border: 1px solid ${({ $color }) => ($color ? `${$color}55` : 'rgba(2, 145, 239, 0.3)')};
`;

const HEX = /^#[0-9a-fA-F]{6}$/;

export default function TagChips({ tags, empty = '-' }) {
  const list = Array.isArray(tags) ? tags.filter(Boolean) : [];
  if (list.length === 0) return <>{empty}</>;
  return (
    <Wrap data-role="candidate-tag-chips">
      {list.map((tag) => (
        <Chip
          key={tag.id || tag.name}
          $color={HEX.test(tag.color || '') ? tag.color : null}
          data-role="candidate-tag-chip"
        >
          {tag.name}
        </Chip>
      ))}
    </Wrap>
  );
}
